import React, { useState } from "react"
import { Grid } from "@material-ui/core"
import Collapsible from "react-collapsible"
import { Container as ContainerMui } from "../ContainerMui"
import CollapsibleTriggerComponent from "./CollapsibleTriggerComponent"
import ContentWrapper from "./ContentWrapper"
import ContentItem, { ContentItemBody, ContentItemHeader } from "./ContentItem"
import { Col, Container, Row } from "react-grid-system"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"
import { Fade } from "react-reveal"

const StyledSection = styled.section`
  z-index: 3;
  position: relative;
  overflow-x: hidden;
  margin-bottom: 30px;
  margin-top: 30px;

  ${breakpoint.sm} {
    margin-bottom: 40px;
    margin-top: 40px;
  }

  ${breakpoint.md} {
    margin-bottom: 70px;
    margin-top: 70px;
  }
  ${breakpoint.lg} {
    margin-bottom: 120px;
    margin-top: 120px;
  }
`
const StyledColItemWrapper = styled.div`
  margin-bottom: 8%;

  ${breakpoint.sm} {
    margin-bottom: 5%;
  }
  ${breakpoint.md} {
    margin-bottom: 4%;
  }
  ${breakpoint.lg} {
    margin-bottom: 0;
  }
`

const ContentBodyWrapper = styled.div`
  margin-bottom: 10px;

  ${breakpoint.lg} {
    margin-bottom: 0px;
  }
`

const AccordianSection = () => {
  const [currentAccordianItem, setCurrentAccordianItem] = useState("")

  const handleAccordianTriggerClick = accordianPosition => {
    if (accordianPosition === currentAccordianItem) {
      setCurrentAccordianItem("")
      return
    }
    setCurrentAccordianItem(accordianPosition)
  }

  return (
    <StyledSection>
      <Fade ssrReveal>
        <Collapsible
          trigger={
            <CollapsibleTriggerComponent
              title="Initial Screen"
              isOpened={currentAccordianItem === "01"}
              triggerBackgroundColor="#0F6497"
            />
          }
          handleTriggerClick={handleAccordianTriggerClick}
          accordionPosition="01"
          open={currentAccordianItem === "01"}
          transitionTime={200}
        >
          <ContentWrapper style={{ backgroundColor: "#0F6497" }}>
            <Container fluid xs sm md>
              <Row>
                <Col xs={12} lg={6}>
                  <StyledColItemWrapper>
                    <ContentItem title="Impact thesis">
                      <div style={{ marginBottom: "10px" }}>
                        Our impact theses aim to articulate the company’s
                        intended path to delivering impact by identifying
                        strategic elements: inputs, outputs, outcomes, and SDGs.
                      </div>
                      <div>
                        Crafting an impact thesis for each target company helps
                        us better understand how a particular product or service
                        is making impact in the world.
                      </div>
                    </ContentItem>
                  </StyledColItemWrapper>
                </Col>
                <Col xs={12} lg={6}>
                  <ContentItem title="Intentionality">
                    <div>
                      Assessing an entrepreneur’s intentionality and commitment
                      to impact is important for us to ensure a company is able
                      to balance the dual purposes of social or environmental
                      change with financial return.
                    </div>
                  </ContentItem>
                </Col>
              </Row>
            </Container>
          </ContentWrapper>
        </Collapsible>
        <Collapsible
          trigger={
            <CollapsibleTriggerComponent
              title="Impact Analysis"
              isOpened={currentAccordianItem === "02"}
              triggerBackgroundColor="#1E93D1"
            />
          }
          accordionPosition="02"
          handleTriggerClick={handleAccordianTriggerClick}
          open={currentAccordianItem === "02"}
          transitionTime={200}
        >
          <ContentWrapper style={{ backgroundColor: "#1E93D1" }}>
            <Container fluid xs sm md>
              <Row>
                <Col xs={12} lg={6}>
                  <StyledColItemWrapper>
                    <ContentItem title="FIVE dimensions of Impact">
                      <div>
                        We use the Impact Management Project as a consistent
                        method of assessing the impact performance of different
                        investments, using the five dimensions of impact: WHAT,
                        WHO, HOW MUCH, CONTRIBUTION and RISK.
                      </div>
                    </ContentItem>
                  </StyledColItemWrapper>
                </Col>
                <Col xs={12} lg={6}>
                  <ContentItem title="Scoring system">
                    <div style={{ marginBottom: "10px" }}>
                      We evaluate and score companies across each impact
                      dimension.
                    </div>
                    <div>
                      Our scoring system defines a minimum threshold for impact
                      and therefore ensures that all deals meet a required
                      baseline for impact.
                    </div>
                  </ContentItem>
                </Col>
              </Row>
            </Container>
          </ContentWrapper>
        </Collapsible>
        <Collapsible
          trigger={
            <CollapsibleTriggerComponent
              title="Portfolio Engagement"
              isOpened={currentAccordianItem === "03"}
              triggerBackgroundColor="#60686F"
            />
          }
          accordionPosition="03"
          handleTriggerClick={handleAccordianTriggerClick}
          open={currentAccordianItem === "03"}
          transitionTime={200}
        >
          <ContentWrapper style={{ backgroundColor: "#60686F" }}>
            <div style={{ marginBottom: "16px" }}>
              <Container fluid xs sm md>
                <Row>
                  <Col xs={12} lg={6}>
                    <StyledColItemWrapper>
                      <ContentItemHeader>ACTIVE PARTNERSHIP</ContentItemHeader>
                    </StyledColItemWrapper>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} lg={6}>
                    <ContentItemBody>
                      <ContentBodyWrapper>
                        Post investment, we continue to take a strong interest
                        in how our portfolio companies achieve impact and
                        support them in their impact journey. We work closely
                        with management teams throughout the life of the
                        investments to achieve the growth, value and impact
                        targets we envision for our portfolio companies.
                      </ContentBodyWrapper>
                    </ContentItemBody>
                  </Col>
                  <Col xs={12} lg={6}>
                    <ContentItemBody>
                      <div>
                        For example, we actively engage Sunseap, our first
                        investment and a partner in accelerating Asia’s
                        decarbonisation and transition to clean energy.
                        Together, we exchange ideas and develop innovative and
                        commercially viable solutions that foster sustainability
                        and fight climate change in new markets.
                      </div>
                    </ContentItemBody>
                  </Col>
                </Row>
              </Container>
            </div>
          </ContentWrapper>
        </Collapsible>
      </Fade>
    </StyledSection>
  )
}

export default AccordianSection
